import { m8API } from 'services/production/m8';

export const getDemoStackUrl = async (): Promise<string | null> => {
  const info = await m8API.user.getDemoStackInfo();

  if (info) {
    return info.linkLogin;
  }

  return null;
};
